<template>
  <li :class="$style.listItem">
    <icon
        v-if="icon"
        :icon="icon"
        :class="$style.iconLeft"
    ></icon>
    <div :class="$style.listText"><slot></slot></div>
    <icon
        v-if="showInfo"
        @click.native="infoClicked"
        icon="info-filled"
        :class="$style.infoIcon"
    ></icon>
  </li>
</template>

<script>
  import icon from "../display/icon";

  export default {
    name: "list-item-fragment",
    components: { icon },
    props : {
      icon: { type: String, default: "check" },
      showInfo: { type: Boolean, default: false }, // Show info icon
    },
    methods: {
      infoClicked() {
        this.$emit("info-clicked");
      }
    }
}
</script>

<style module lang="scss">
    @import "../../style/abstract/abstract.functions.scss";
    @import "../../style/abstract/abstract.typography.scss";
    @import "../../style/abstract/abstract.spacing";
    @import "../../style/modules/input.module";

    .listItem {
      font-weight: bold;
      background-color: transparent;
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: rem-calc($spacing-s);
    }

    .listText {
      margin-left: rem-calc($spacing-xs);
    }

    .iconLeft {
      color: #30ab7a;
      font-size: 24px;
    }

    .infoIcon {
      composes: info;
    }
</style>